import { Navigate, useMatch } from "react-router";
import { CHECKOUT_BUYER, SUPPLIER, SUPPLIERS } from "../../../constants/routes";

export const CheckoutV2Redirect = () => {
  const supplierIdOrUrlId = useMatch({
    path: SUPPLIER.pattern,
    end: false,
  })?.params.supplierIdOrUrlId;
  if (!supplierIdOrUrlId) return <Navigate to={SUPPLIERS} replace />;

  return <Navigate to={CHECKOUT_BUYER.href({ supplierIdOrUrlId })} replace />;
};
